export type PaddingSize = 'none' | 'small' | 'medium' | 'large' | 'xlarge';

export const paddingOptions = [
    { label: "None", value: "none" },
    { label: "Small", value: "small" },
    { label: "Medium", value: "medium" },
    { label: "Large", value: "large" },
    { label: "XLarge", value: "xlarge" },
];

export const paddingMap = {
    none: '0',
    small: '12',  // 48px
    medium: '20', // 80px
    large: '24',  // 96px
    xlarge: '36', // 144px
};

export const getPaddingClasses = (
    mobilePaddingTop: keyof typeof paddingMap,
    desktopPaddingTop: keyof typeof paddingMap,
    mobilePaddingBottom: keyof typeof paddingMap,
    desktopPaddingBottom: keyof typeof paddingMap
) => {
    const mobileTopClasses: Record<keyof typeof paddingMap, string> = {
        none: 'mobile-pt-none',
        small: 'mobile-pt-small',
        medium: 'mobile-pt-medium',
        large: 'mobile-pt-large',
        xlarge: 'mobile-pt-xlarge',
    };

    const desktopTopClasses: Record<keyof typeof paddingMap, string> = {
        none: 'desktop-pt-none',
        small: 'desktop-pt-small',
        medium: 'desktop-pt-medium',
        large: 'desktop-pt-large',
        xlarge: 'desktop-pt-xlarge',
    };

    const mobileBottomClasses: Record<keyof typeof paddingMap, string> = {
        none: 'mobile-pb-none',
        small: 'mobile-pb-small',
        medium: 'mobile-pb-medium',
        large: 'mobile-pb-large',
        xlarge: 'mobile-pb-xlarge',
    };

    const desktopBottomClasses: Record<keyof typeof paddingMap, string> = {
        none: 'desktop-pb-none',
        small: 'desktop-pb-small',
        medium: 'desktop-pb-medium',
        large: 'desktop-pb-large',
        xlarge: 'desktop-pb-xlarge',
    };

    return [
        'responsive-padding',
        mobileTopClasses[mobilePaddingTop],
        desktopTopClasses[desktopPaddingTop],
        mobileBottomClasses[mobilePaddingBottom],
        desktopBottomClasses[desktopPaddingBottom]
    ].join(' ');
};
